import debounce from 'lodash.debounce';

class Scroll {


  constructor() {
    this.events = ['mousewheel', 'touchmove'];
    this.locked = false;
    this._threshold = 0;
    this._thresholdLimit = window.innerWidth > 500 ? 10 : 30;
    this._lock = e => {
      this._threshold += 1;

      this.resetThresholdAfterTimeout();

      if (this._threshold > this._thresholdLimit) {
        this.unlock();
        return true;
      }
      e.preventDefault();      
    }

    this.resetThresholdAfterTimeout = debounce(this._resetThresholdAfterTimeout, 300);
  }

  _resetThresholdAfterTimeout() {
    this._threshold = 0;
  } 

  lock() {
    if (this.locked) return;
    this.events.forEach(ev => {
      window.addEventListener(ev, this._lock, { passive: false });
    });
    this.locked = true;
  }

  unlock() {
    if (!this.locked) return;
    this._threshold = 0;
    this.events.forEach(ev => {
      window.removeEventListener(ev, this._lock, { passive: false });
    });
    this.locked = false;
  }
}

export default new Scroll(); 